module.exports = __webpack_public_path__ + "static/assets/92ce550a8e78c714b655580a03f37ddd.png";